import { createContext, useContext, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { Preloader } from "./Preloader";

const SiteCtx = createContext({ hero: false, setHero: () => {}, menu: [] });
export const useHero = () => useContext(SiteCtx).setHero;
export const useSite = () => useContext(SiteCtx);

export default function SiteLayout() {
  const { pathname } = useLocation();
  const [hero, setHero] = useState(false);
  const [menu, setMenu] = useState([]);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => { api.get("/public/menu").then((r) => setMenu(r.data)).catch(() => {}); }, []);
  return (
    <SiteCtx.Provider value={{ hero, setHero, menu }}>
      <div className="min-h-screen flex flex-col bg-ivory">
        <Header />
        <main className="flex-1">
          <div key={pathname} className="page-in">
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
      <CookieBanner />
      <Preloader />
    </SiteCtx.Provider>
  );
}
